import { buildAssetProducts } from './buildAssetProducts';

/** Product catalog from uploaded images in src/assets/Website Photos */
export const products = buildAssetProducts();
